<ul class="menu-list" *ngIf="showMenu" >
    
        <li *ngFor="let item of steps;let i= index" tourAnchor="{{item.tourAnchor}}">
           <ng-container *ngIf="checkType(item)">
            <a *ngIf="hasPermission(i)" [ngClass]="{'active': item.isActive === true}"  placement="right" (click)="showSubMenuitem(item,$event)"  ngbTooltip="{{item.tooltip}}"> <span class="{{item.label}}"></span></a>
            <a ngbTooltip="Access Restricted" *ngIf="!hasPermission(i)" placement="right" class="disabled" (click)=onStopPropagation($event)><span class="{{item.label}}"></span></a>
           </ng-container>
            
            
            <!-- <a *ngIf="hasPermission(i)" [ngClass]="{'active': item.isActive === true}" placement="right" ngbTooltip="{{item.tooltip}}"> -->
        </li>
    
  

    <app-sub-menu *ngIf="showSubMenu" ></app-sub-menu>
</ul>
<tour-step-template *ngIf="!tourService?.steps?.includes(tourService.currentStep)  ">
  <ng-template let-step="step">
      <p class="tour-step-content" [innerHTML]='step?.content'></p>
      <div class="tour-step-navigation">
          <button *ngIf="tourService.hasPrev(step)" class="btn btn-sm btn-default" (click)="tourService.prev()"> {{step?.prevBtnTitle}}</button>
          <button *ngIf="tourService.hasNext(step)" class="btn btn-sm btn-default nxt-btn" (click)="tourService.next()">{{step?.nextBtnTitle}} {{tourService.steps.indexOf(tourService.currentStep)+1}}/{{tourService.steps?.length}}</button>
          <button class="btn btn-sm btn-default" (click)="tourService.end()">{{tourService.hasNext(step)?'Skip':'End'}}</button>
      </div>
  </ng-template>
</tour-step-template>